import React from 'react'
import classNames from 'classnames/bind'

import Style from './ResidentAuthVerification.module.scss'

import IconCheckCircleOff from '@Ui/images/myhouse/IconCheckCircleOff'
import IconCheckCircleOn from '@Ui/images/myhouse/IconCheckCircleOn'

const cx = classNames.bind(Style)

type Props = {
  checked: boolean
  setChecked: (value: boolean) => void
}

const ResidentAuthVerification = ({ checked, setChecked }: Props) => {
  return (
    <div className={cx('article')}>
      <h2 className={cx('title')}>
        <span className={cx('highlight')}>집주인 인증</span>을 신청합니다
      </h2>
      <div className={cx('area-description')}>
        <p className={cx('description')}>
          우리집 주소지 등기부등본의 소유주 명과
          <br />
          네이버회원 실명정보의 일치 여부를 확인합니다
          <br />
          인증 완료까지 영업일 기준 1~3일의 대기 시간이
          <br />
          소요됩니다.
        </p>
      </div>
      <div className={cx('area-checkbox')}>
        <div className={cx('checkbox')}>
          <input
            type="checkbox"
            id="alarm"
            checked={checked}
            onChange={() => {
              setChecked(!checked)
            }}
          />
          <label htmlFor="alarm" className={cx('checkbox-label')}>
            <span className={cx('icon-check')}>{checked ? <IconCheckCircleOn width={22} height={22} /> : <IconCheckCircleOff width={22} height={22} />}</span>
            인증이 완료되면 알림을 받겠습니다.
            <span className={cx('sub-text')}>네이버앱 알림 및 모바일 푸시 메시지가 전송됩니다.</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default ResidentAuthVerification
